// Footer'daki "Arşiv" alanı.
//
// Arşive alınan lig ve sezonlar site geneli filtrelerden, maç oluşturma
// ekranından ve içerik havuzundan kalkar. Eski lig/sezonlara ulaşmak
// isteyenler bu alanı açıp doğrudan ilgili sezona gidebilir; tam liste için
// /arsiv sayfası var.
//
// Veri yalnızca alan ilk kez açıldığında çekilir — her sayfa yüklenişinde
// gereksiz bir istek atılmasın.
import React, { useCallback, useState } from "react";
import { Link } from "react-router-dom";

import { archiveApi } from "../../services/archiveApi";

const seg = (value) => encodeURIComponent(String(value ?? ""));

const seasonPath = (cityId, leagueId, seasonId) =>
  cityId && leagueId && seasonId
    ? `/sehir/${seg(cityId)}/lig/${seg(leagueId)}/sezon/${seg(seasonId)}/anasayfa`
    : "";

export default function FooterArchive() {
  const [open, setOpen] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [cities, setCities] = useState([]);

  const load = useCallback(async () => {
    if (loaded || loading) return;
    setLoading(true);
    setError("");
    try {
      const data = await archiveApi.tree();
      setCities(Array.isArray(data?.cities) ? data.cities : []);
      setLoaded(true);
    } catch (requestError) {
      setError("Arşiv şu anda yüklenemedi.");
    } finally {
      setLoading(false);
    }
  }, [loaded, loading]);

  const toggle = () => {
    setOpen((prev) => {
      const next = !prev;
      if (next) load();
      return next;
    });
  };

  return (
    <div className={`el-footer-archive ${open ? "is-open" : ""}`}>
      <button
        type="button"
        className="el-footer-archive__toggle"
        aria-expanded={open}
        onClick={toggle}
      >
        <span>
          <i className="fa-solid fa-box-archive" aria-hidden="true" /> Arşiv
        </span>
        <small>Tamamlanan lig ve sezonlar</small>
        <i className="fa-solid fa-chevron-down el-footer-archive__caret" aria-hidden="true" />
      </button>

      {open && (
        <div className="el-footer-archive__panel">
          {loading && <p className="el-footer-archive__state">Arşiv yükleniyor…</p>}

          {!loading && error && <p className="el-footer-archive__state">{error}</p>}

          {!loading && !error && loaded && cities.length === 0 && (
            <p className="el-footer-archive__state">Arşive alınmış lig veya sezon yok.</p>
          )}

          {!loading && !error && cities.length > 0 && (
            <div className="el-footer-archive__cities">
              {cities.map((city) => (
                <div key={city.id || city.label} className="el-footer-archive__city">
                  <h4>{city.label}</h4>

                  {city.leagues.map((league) => (
                    <div key={league.id} className="el-footer-archive__league">
                      <strong>{league.label}</strong>

                      <ul>
                        {league.seasons.map((season) => {
                          const to = seasonPath(city.id, league.id, season.id);
                          if (!to) return null;
                          return (
                            <li key={season.id}>
                              <Link to={to}>{season.label}</Link>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          )}

          <Link to="/arsiv" className="el-footer-archive__all">
            Tüm arşivi gör
          </Link>
        </div>
      )}
    </div>
  );
}
